import { objectToQueryString } from "../../../helpers/objectToQueryString";
import { API } from "../../api";
async function getAddressFromLatLng(request) {
    return await new API().apiGet({
        baseUrl: process.env.LETS_TRADE_INTEGRATION_URL ?? "",
        endpoint: `v1/google/coordinate/geocode${objectToQueryString(request)}`,
    });
}
export { getAddressFromLatLng };
